import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import { isCandidateDataVisible } from '../utils';

@Pipe({
  name: 'isCandidateDataVisible',
  standalone: true,
})
export class IsCandidateDataVisiblePipe implements PipeTransform {
  public transform(candidate?: { isRevealed?: boolean; isAnonymous?: boolean } | null): boolean {
    if (!candidate) {
      return true;
    }

    return isCandidateDataVisible(candidate);
  }
}
